/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Validuntil1Inputs */

const de__field_validuntil1 = /** @type {(inputs: _Field_Validuntil1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbar bis`)
};

/**

* @param {_Field_Validuntil1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_validuntil1 = /** @type {((inputs?: _Field_Validuntil1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Validuntil1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_validuntil1(inputs)
});
export { _field_validuntil1 as "_field_validUntil" }